"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.userGroups = exports.emptyGroup = exports.group = void 0;
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const membership_1 = __importStar(require("./membership"));
exports.group = {
    avatar: membership_1.mockAvatar,
    identifier: 1,
    isAdmin: false,
    isFounder: false,
    name: 'Group name',
    founder: 1,
    isReadonly: false,
    information: 'Group information',
    lecturesCount: 2,
    members: [membership_1.default],
    quizzesCount: 3,
    recordingsCount: 4,
    screensCount: 5,
    lastActivityTime: Date.parse('2022-10-25 14:50:24'),
    membersCount: 1,
    questionsCount: 0,
    coursesCount: 0,
    canLeave: true,
};
exports.emptyGroup = {
    identifier: bridge_schema_1.GroupID.New,
    name: '',
    information: '',
    avatar: '',
    isFounder: false,
    isAdmin: false,
    isReadonly: false,
    founder: 1,
    screensCount: 0,
    quizzesCount: 0,
    recordingsCount: 0,
    lecturesCount: 0,
    members: [],
    lastActivityTime: Date.parse('2022-10-25 14:50:24'),
    membersCount: 1,
    questionsCount: 0,
    coursesCount: 0,
    canLeave: true,
};
exports.userGroups = [
    {
        identifier: 200,
        name: 'My Group',
        information: 'Bla bla bla',
        avatar: 'https://cdn.3d4medical.com/complete_anatomy-userdata/11938/groups/20170713_150903.jpeg',
        isFounder: true,
        isAdmin: true,
        isReadonly: false,
        founder: 1,
        screensCount: 10,
        quizzesCount: 5,
        recordingsCount: 21,
        lecturesCount: 3,
        members: [],
        lastActivityTime: Date.parse('2022-10-25 14:50:24'),
        membersCount: 1,
        questionsCount: 0,
        coursesCount: 0,
        canLeave: true,
    },
    {
        identifier: 201,
        name: 'General',
        information: 'Bla bla bla',
        avatar: 'https://cdn.3d4medical.com/complete_anatomy-userdata/11938/groups/20170713_150903.jpeg',
        isFounder: true,
        isAdmin: true,
        isReadonly: false,
        founder: 1,
        screensCount: 10,
        quizzesCount: 5,
        recordingsCount: 21,
        lecturesCount: 3,
        members: [],
        lastActivityTime: Date.parse('2022-10-19 14:50:24'),
        membersCount: 1,
        questionsCount: 0,
        coursesCount: 0,
        canLeave: true,
    },
    {
        identifier: 202,
        name: 'Test Group 2',
        information: '',
        avatar: '',
        isFounder: false,
        isAdmin: false,
        isReadonly: false,
        founder: 1,
        screensCount: 12,
        quizzesCount: 34,
        recordingsCount: 555,
        lecturesCount: 7,
        members: [],
        lastActivityTime: Date.parse('2022-10-21 14:50:24'),
        membersCount: 1,
        questionsCount: 0,
        coursesCount: 0,
        canLeave: true,
    },
    {
        identifier: 203,
        name: 'Test Group 3',
        information: '',
        avatar: 'https://cdn.3d4medical.com/accounts/upload/121070/images/avatar_20170419_120654.jpeg',
        isFounder: false,
        isAdmin: false,
        isReadonly: false,
        founder: 1,
        screensCount: 121,
        quizzesCount: 4,
        recordingsCount: 10,
        lecturesCount: 7,
        members: [],
        lastActivityTime: Date.parse('2022-10-12 14:50:24'),
        membersCount: 1,
        questionsCount: 0,
        coursesCount: 0,
        canLeave: true,
    },
    {
        identifier: 204,
        name: 'Bla',
        information: '',
        avatar: 'https://cdn.3d4medical.com/accounts/upload/121070/images/avatar_20170419_120654.jpeg',
        isFounder: false,
        isAdmin: false,
        isReadonly: false,
        founder: 1,
        screensCount: 121,
        quizzesCount: 4,
        recordingsCount: 10,
        lecturesCount: 7,
        members: [],
        lastActivityTime: Date.parse('2022-10-15 14:50:24'),
        membersCount: 1,
        questionsCount: 0,
        coursesCount: 0,
        canLeave: true,
    },
];
